import { EventsManager, ReelsEvents, WinEvents } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { ShakeProps } from "../../../abstracts/types/interfaces";
import { shake } from "../../../abstracts/utils/GraphicUtils";
import { DDD } from "../../DDD";
import { DDDReelsView } from "./DDDReelsView";

export class DDDReelsController extends AbstractModuleController {
    public get name(): string {
        return `DDDReelsController`;
    }

    public get view(): DDDReelsView {
        if (this._view === undefined || this._view === null) {
            this._view = new DDDReelsView();
        }
        return this._view as DDDReelsView;
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.trigger(ReelsEvents.GET_REELS_VIEW, this.view);

        EventsManager.trigger(ReelsEvents.GET_REELS, this.view.getReels());

        EventsManager.on(WinEvents.SHAKE_NORMAL_SCREEN, (shakeProps: ShakeProps) => {
            shake({
                displayObject: this.view,
                intensity: shakeProps.intensity,
                defaultX: shakeProps.defaultX ? shakeProps.defaultX : 0,
                defaultY: shakeProps.defaultY ? shakeProps.defaultY : 0,
                duration: shakeProps.duration ? shakeProps.duration : 0.1,
                repeat: shakeProps.repeat ? shakeProps.repeat : 1,
            });
        });
    }

    protected handleView(): void {
        super.handleView();

        let currentReels: string[][] = Object.assign([], DDD.model.data.reels);

        this.view.generateInitialReels(currentReels);
    }
}
